import { ca } from '@cian/analytics';

export function trackClickGenplanSeoLink() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'building_plan_seo_url',
    useLastProducts: true,
  });
}
